<template>
  <van-overlay class="global-loading" :show="visible" :z-index="zIndex">
    <div class="loading-content">
      <van-loading :size="size" :color="color" type="spinner" vertical>
        {{ text }}
      </van-loading>
    </div>
  </van-overlay>
</template>

<script setup>
const visible = ref(false)
const text = ref('加载中...')
const size = ref('24px')
const color = ref('#FFFFFF')
const zIndex = ref(2000)

function show (options = {}) {
  text.value = options.text || '加载中...'
  size.value = options.size || '24px'
  color.value = options.color || '#FFFFFF'
  zIndex.value = options.zIndex || 2000
  visible.value = true
}

function hide() {
  visible.value = false
}

let needLoadingRequestCount = 0;
const tryShow = () => {
  if (needLoadingRequestCount === 0) {
    show();
  }
  needLoadingRequestCount++;
}

const tryHide = () => {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    hide();
  }
}

defineExpose({
  tryShow,
  tryHide
});
</script>

<style scoped lang="scss">
.global-loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000000;
  z-index: 3000 !important;
  left: 0;
  top: 0;

  .loading-content {
    width: 100px;
    height: 100px;
    background: #000000cc;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}
</style>
